import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconSadSuitcase: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 64,
        height: 56,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17 4.571h5c1.1 0 2 .9 2 2v14.858c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V6.571c0-1.1.9-2 2-2h5V2.286A2.294 2.294 0 0 1 9.286 0h5.428A2.293 2.293 0 0 1 17 2.286zm-1 2H6v14.858h12V6.571zm-1-4.285H9v2.285h6zM4 6.571H2v14.858h2zm16 0v14.858h2V6.571zM9.4 17.929c-.4-.4-.5-1-.1-1.4l.018-.018c.175-.18 1.245-1.282 2.682-1.282 1.036 0 1.882.573 2.405.927.234.158.403.273.495.273.3.4.3 1-.1 1.4-.2.2-.5.3-.7.3s-.5-.1-.7-.3-.8-.7-1.3-.7c-.6 0-1.2.6-1.3.7-.4.4-1 .5-1.4.1M9 12.571a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-1a1 1 0 1 1-2 0 1 1 0 1 1 2 0',
    })
  )
}
